import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddNewSubAssembly = ({ isAddOpen, onAddClose, formData, setFormData, id }) => {
  if (!isAddOpen) return null;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  console.log("Form Submit Triggered");
  console.log("Form Data:", formData); // Check if sa is present

  // 🔹 Validation for Sub Assembly
  if (!formData.sa || formData.sa.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Sub Assembly!",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const payload = {
      sa: formData.sa,
      id: id,
    };

    console.log("Payload being sent to server:", payload);

    const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/add_sub_assembly_api`, payload);

    console.log("Server response:", response.data);

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Inserted!",
        text: "Sub Assembly inserted successfully.",
      });
      onAddClose();
      window.location.reload();
    } else {
      console.warn("Insert failed, no 'success' in response:", response.data);
      Swal.fire({
        icon: "error",
        title: "Insert Failed",
        text: response.data.message || "Unknown error.",
      });
    }

  } catch (error) {
    console.error("Error inserting:", error);

    if (error.response) {
      console.error("Error Response Data:", error.response.data);
    }

    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Insert failed. Please try again.",
      });
    }
  }
};


  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onAddClose} style={{position: "initial"}}>&times;</button>
        </div>
        <h3>Add New Sub Assembly</h3>
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
            <div className="form-group">
                <label>Sub Assembly :</label>
                <input
            type="text"
            name="sa"
            value={formData.sa}
            onChange={handleChange}
          />
              </div> 
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Save
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default AddNewSubAssembly;
